import { Clock, Zap, ShieldCheck } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/site/Reveal";

const features = [
  { icon: Clock, title: "24/7 Access", body: "Always on. Fuel whenever you train or work." },
  { icon: Zap, title: "60-Second Blend", body: "Fresh, chilled and ready in under a minute." },
  { icon: ShieldCheck, title: "Lab Tested", body: "Every batch backed by nutritional certificates." },
];

export default function Machine() {
  return (
    <section id="machine" data-testid="machine" className="relative bg-[#D9F4CD] py-24 md:py-40 border-t border-[#17320B]/10 overflow-hidden">
      <img src={IMAGES.beads} alt="" aria-hidden className="pointer-events-none absolute right-0 top-10 w-[46vw] max-w-[560px] opacity-20 select-none" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-14 md:mb-20">
            <span className="font-mono-eb text-xs uppercase tracking-[0.3em] text-[#7B9C62]">/ The Machine</span>
            <span className="h-px flex-1 bg-[#17320B]/15" />
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-12 lg:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div className="relative aspect-[7/15] overflow-hidden rounded-lg border border-[#17320B]/10 bg-white flex items-center justify-center mx-auto max-w-[420px] shadow-xl shadow-[#17320B]/5">
                <img src={IMAGES.machine} alt="TheMacroBar protein shake vending machine" className="h-full w-full object-cover" />
                <div className="absolute top-5 left-5 font-mono-eb text-[10px] uppercase tracking-[0.2em] bg-[#17320B] text-[#D9F4CD] px-3 py-1.5 rounded-full">
                  Smart Vending
                </div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tighter leading-[0.9] text-[#17320B]">
                A wellness<br />
                <span className="text-[#7B9C62]">destination,</span><br />
                shrunk to a machine.
              </h2>
              <p className="mt-8 max-w-md text-[#17320B]/70 text-base md:text-lg leading-relaxed">
                Our smart vending unit refrigerates real ingredients and flash-blends them to order.
                A full-colour touchscreen guides you, UPI keeps it cashless, and the whole thing fits
                neatly in any gym corner, office lobby or campus.
              </p>
            </Reveal>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              {features.map((f, i) => (
                <Reveal key={f.title} delay={i * 0.08}>
                  <div className="border border-[#17320B]/12 bg-white rounded-sm p-5 h-full hover:border-[#7B9C62] transition-colors duration-400">
                    <f.icon size={22} className="text-[#7B9C62] mb-3" />
                    <div className="font-display uppercase text-lg tracking-tight text-[#17320B]">{f.title}</div>
                    <div className="text-[#17320B]/55 text-sm mt-1 leading-snug">{f.body}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
